export default __webpack_public_path__ + "static/media/MM-Seas-LogoReversed-noTM.0097edd5.png";